export const modifyDeviceTypeMutation = () =>
    `mutation updateDeviceType($input: UpdateDeviceType!) {
      updateDeviceType(
        input: $input
      )
    }`;
